/**
 * Action Trigger Card Component
 *
 * Selection card used in the Create Automation Wizard for both
 * action selection and trigger selection steps.
 */

import { FC } from 'react';
import { Card, CardActionArea, CardContent } from 'src/components/Card';
import { Stack } from 'src/components/Stack';
import { Typography } from 'src/components/Typography';

interface ActionTriggerCardProps {
  title: string;
  description?: string;
  onClick?: () => void;
  selected?: boolean;
}

export const ActionTriggerCard: FC<ActionTriggerCardProps> = ({
  title,
  description,
  onClick,
  selected = false,
}) => (
  <Card
    elevation={0}
    sx={(theme) => ({
      height: '100%',
      border: '1px solid',
      borderColor: selected ? 'primary.main' : 'divider',
      bgcolor: selected
        ? `rgba(${theme.vars.palette.primary.mainChannel} / 0.06)`
        : undefined,
      boxShadow: selected
        ? `inset 0 0 0 1px ${theme.vars.palette.primary.main}`
        : undefined,
      transition: 'all 0.15s ease-in-out',
      '&:hover': {
        borderColor: 'primary.main',
        bgcolor: selected
          ? `rgba(${theme.vars.palette.primary.mainChannel} / 0.08)`
          : 'action.hover',
      },
    })}
  >
    <CardActionArea
      onClick={onClick}
      sx={{
        height: '100%',
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
      }}
    >
      <CardContent sx={{ p: 2, width: '100%' }}>
        <Stack spacing={0.5}>
          <Typography variant="subtitle1" sx={{ textTransform: 'capitalize' }}>
            {title}
          </Typography>
          {description && (
            <Typography variant="body2" color="text.secondary">
              {description}
            </Typography>
          )}
        </Stack>
      </CardContent>
    </CardActionArea>
  </Card>
);

